import { Injectable } from '@angular/core';
import { SeverityNumber, logs } from '@opentelemetry/api-logs';
import {
  INGXLoggerConfig,
  INGXLoggerMetadata,
  INGXLoggerServerService,
  NgxLoggerLevel,
} from 'ngx-logger';

@Injectable()
export class OTELLoggerWriterService implements INGXLoggerServerService {
  public sendToServer(
    metadata: INGXLoggerMetadata,
    config: INGXLoggerConfig,
  ): void {
    if (metadata.level < (config.serverLogLevel ?? NgxLoggerLevel.OFF)) return;
    const severity = this.toSeverityNumber(metadata.level);

    const otelLogger = logs.getLogger(metadata.fileName!);

    otelLogger.emit({
      severityNumber: severity,
      severityText: SeverityNumber[severity],
      body: metadata.message,
      attributes: {
        'log.type': 'ngx-logger',
        'logger.name': metadata.fileName!,
        ...this.toAttributes(metadata),
      },
    });
  }

  public flushQueue(): void {
    //batching handled by log exporter
  }

  private toSeverityNumber(level: NgxLoggerLevel): SeverityNumber {
    switch (level) {
      case NgxLoggerLevel.TRACE:
        return SeverityNumber.TRACE;
      case NgxLoggerLevel.DEBUG:
        return SeverityNumber.DEBUG;
      case NgxLoggerLevel.INFO:
        return SeverityNumber.INFO;
      case NgxLoggerLevel.LOG:
        return SeverityNumber.INFO;
      case NgxLoggerLevel.WARN:
        return SeverityNumber.WARN;
      case NgxLoggerLevel.ERROR:
        return SeverityNumber.ERROR;
      case NgxLoggerLevel.FATAL:
        return SeverityNumber.FATAL;
      case NgxLoggerLevel.OFF:
        return SeverityNumber.UNSPECIFIED;
      default:
        return SeverityNumber.UNSPECIFIED;
    }
  }

  private toAttributes(metadata: INGXLoggerMetadata): Record<string, unknown> {
    const { message, additional } = metadata;

    const regex = /\{(\w+)\}/g;
    let match;
    const result: Record<string, unknown> = {};

    let index = 0;
    while ((match = regex.exec(message)) !== null) {
      result[match[1]] = additional![index++];
    }
    for (let i = index; i < additional!.length; i++) {
      result[i] = additional![i];
    }
    return result;
  }
}
